// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"4da9eb03","414":"4e99bb3b","476":"081a7d90","482":"3c554d59","503":"c93ac5ad","837":"91ee978d"}[chunkId] + ".css";
};